import Container from '@/components/Container';
import Stepper from '@/components/Stepper';
import { Outlet, useLocation } from 'react-router-dom';

export function OnboardingContainer() {
  const location = useLocation();

  const match = location.pathname.match(/step-(\d+)/);
  const stepNumber = match ? parseInt(match[1], 10) : 1;

  return (
    <Container>
      <div className="col-span-12 mt-sh-60 flex flex-col items-center justify-center px-4 md:col-start-3 md:col-end-11">
        <Stepper steps={5} step={stepNumber - 1} />
        <Outlet />
      </div>
    </Container>
  );
}
